<template>
  <div>
    <PageTitle title="Stock Details" :btnCreate="true" />

    <v-container fluid class="lighten-12 content">
      <!-- <hr style="border-top: 1px dashed rgb(173 173 173)" /> -->
      <v-card class="lighten-12 card-content">
        <TableFilters
          :filters="['product', 'warehouse', 'damage', 'stock']"
          v-model="filter"
          :columns="columns"
        ></TableFilters>
      </v-card>

      <v-card class="mt-2">
        <v-container fluid>
          <v-row>
            <v-card-text class="pa-0">
              <v-data-table
                :items-per-page="paginationOptions.perPage"
                :fixed-header="true"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                @click:row="GetBatchDetails($event)"
                show-expand
                :headers="headers"
                :items="stocks"
                item-key="id"
                hide-default-footer
                class="row-pointer product-list"
                expand
                dense
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-btn
                      @click="openTransferModal()"
                      v-if="transferToggle && selectedItemToTransfer.length > 0"
                      color="primary"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Transfer
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-switch
                      v-model="transferToggle"
                      label="Transfer Stock"
                      class="mt-2"
                    ></v-switch>
                  </v-toolbar>
                </template>

                <template v-slot:item.available_stock="{ item }">
                  <v-chip
                    :x-small="true"
                    class="ma-2"
                    label
                    text-color="white"
                    :color="getStockColor(item)"
                    dark
                    >{{ item.available_stock }}</v-chip
                  >
                </template>
                <template v-slot:expanded-item="{ headers, item: childItem }">
                  <td :colspan="headers.length">
                    <v-card class="pa-0 mt-3 mb-3">
                      <v-data-table
                        dense
                        :items="stockBatches"
                        :headers="batchHeaders"
                        class="sub-table"
                      >
                        <template v-slot:item.chktransfer="{ item }">
                          <v-checkbox
                            v-if="transferToggle && item.available_stock > 0"
                            v-model="item.isTransfer"
                            color="indigo darken-3"
                            @change="AddItemToTransfer(item)"
                            hide-details
                          ></v-checkbox>
                        </template>
                        <v-progress-linear
                          v-show="progressBar"
                          slot="progress"
                          color="blue"
                          indeterminate
                        ></v-progress-linear>
                      </v-data-table>
                    </v-card>
                  </td>
                </template>
                <template v-slot:no-data>
                  <img
                    style="height: 200px"
                    src="../../../assets/img/no-result.jpg"
                  />
                </template>
  <template v-slot:item.image="{ item }">
                  <v-dialog v-model="dialog" max-width="60vw">
                    <img
                      :src="loadimage"
                      alt=""
                      width="100%"
                      @click.stop="dialog = false"
                      
                    />
                  </v-dialog>
                  <v-avatar
                    size="32px"
                    item
                    color="primary"
                   
                     
                  >
                    <img
                      v-if="item.product.image"
                      height="30"
                      width="30"
                      :src="item.product.image"
                      style="border-radius: 30%"
                     @mouseover.stop="dialog = true"
                      @mouseover="changeimage(item.product.image)"
                    />

                    <span
                      v-else
                      class="white--text subtitle-2 text-uppercase"
                      >{{  item.product.name.substring(0, 2) }}</span
                    >
                  </v-avatar>
                </template>
                
                <template
                  v-slot:item.data-table-expand="{ item, isExpanded, expand }"
                >
                  <span
                    @click="GetBatchDetails($event)"
                    v-if="
                      (expanded.length > 0 && item.id != expanded[0].id) ||
                      expanded.length == 0
                    "
                    class="mdi mdi-chevron-double-down"
                  ></span>
                  <span
                    @click="GetBatchDetails($event)"
                    v-if="expanded.length > 0 && item.id == expanded[0].id"
                    class="mdi mdi-chevron-double-up"
                  ></span>
                </template>
                <template v-slot:footer>
                  <pagination
                    @paginationOptions="setPaginationOptions"
                    @response="setResponseData"
                    url="stocks"
                    :filter="filter"
                    ref="pagination"
                  />
                </template>
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>

      <div class="d-flex justify-center align-center"></div>
      <!-- </v-row> -->
      <TransferStockModal
        :productList="selectedItemToTransfer"
        ref="TransferForm"
        @success="refreshStocks()"
      />
    </v-container>
  </div>
</template>

<script>
// Components
import TransferStockModal from "./TransferStockModal";

import PageTitle from "@/components/shared/PageTitle";
import pagination from "../../shared/components/pagination";
import TableFilters from "@/components/base/TableFilters";
import uniq from "lodash/uniq";
import { required, email, max } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import BrandAutoComplete from "@/components/base/BrandAutoComplete";
import CategoryAutoComplete from "@/components/base/CategoryAutoComplete";
import StatusAutoComplete from "@/components/base/StatusAutoComplete";
import _ from "lodash";
extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  data: () => ({
     loadimage: "",
    dialog: false,
    transferToggle: false,
    selectedItemToTransfer: [],
    paginationOptions: {},
    progressBar: false,
    batchHeaders: [
      {
        text: "Batch",
        value: "batch.batch",
        show: true,
        
        disabled: true,
        width: "23%",
      },
      {
        text: "In Stock",
        value: "available_stock",
        show: true,
       
        disabled: true,
        width: "30%",
      },
      {
        text: "Damage",
        value: "damage",
        show: true,
        
        disabled: false,
        width: "33%",
      },
      {
        text: "isTransfer",
        value: "chktransfer",
        show: true,
        
        disabled: false,
        width: "25%",
      },
    ],
    columns: [
      {
        text: "Image",
        value: "image",
        show: true,
        disabled: true,
        align: "left",
        width: "14.2%",
      },
      {
        text: "Product",
        value: "product.name",
        show: true,
        disabled: true,
        align: "left",
        width: "14.2%",
      },
      {
        text: "Unit",
        value: "unit.name",
        align: "left",
        show: true,
        disabled: false,
        width: "14.2%",
      },
      {
        text: "Warehouse",
        value: "wareHouse.name",
        show: true,
        disabled: false,
        align: "left",
        width: "14.2%",
      },
      {
        text: "In Stock",
        value: "available_stock",
        show: true,
        disabled: false,
        align: "center",
        width: "14.2%",
      },
      {
        text: "Damage",
        value: "damage",
        show: true,
        disabled: false,
        align: "center",
        width: "16.2%",
      },
      {
        text: "Reorder Level",
        value: "reorder_level",
        show: true,
        disabled: false,
        align: "center",
        width: "14.2%",
      },
    ],
    products: [],
    stocks: [],
    expanded: [],
    singleExpand: true,
    stockBatches: [],
    // Filters
    filter: {
      search: "",
      product: "",
      status: "",
      warehouse: "",
      damage: "",
      stock: "",
    },
  }),
  components: {
    PageTitle,
    ValidationProvider,
    ValidationObserver,
    pagination,
    TableFilters,
    TransferStockModal,
  },
  methods: {
    changeimage(value) {
      this.loadimage = value;
    },
    refreshStocks() {
      this.$refs.pagination.refreshData();
      this.selectedItemToTransfer = [];
      this.transferToggle = [];
      this.selectedProductDetails = null;
      this.expanded = [];
    },
    openTransferModal() {
      this.$refs.TransferForm.openModal();
    },
    AddItemToTransfer(item) {
      
      let product = new Object();
      product = this.selectedProductDetails;
      product = item;
      product.quantity = item.available_stock;
      product.maxStock = item.available_stock;
      product.transferQuantity = item.available_stock;
      product.transferedUnitQuantity = item.available_stock;
      product.sellingPrice = item.sellingPrice;
      product.newSellingPrice = item.sellingPrice;
      product.selectedUnit = item.unit.id;

      product.product = this.selectedProductDetails.product;
      product.unit = item.unit;
      product.batch = item.batch;
      product.units = this.selectedProductDetails.units;
      product.warehouse = this.selectedProductDetails.wareHouse;

      // let productBatch = new Object();
      // productBatch.batchStockDetails = this.selectedProductDetails;
      // productBatch.unitStockDetails = item;
      // productBatch.batchStockDetails.quantity = item.available_stock;
      // productBatch.batchStockDetails.maxStock = item.available_stock;
      // productBatch.batchStockDetails.transferQuantity = item.available_stock;
      // productBatch.batchStockDetails.transferedUnitQuantity =
      //   item.available_stock;
      // productBatch.batchStockDetails.sellingPrice = item.sellingPrice;
      // productBatch.batchStockDetails.newSellingPrice = item.sellingPrice;
      // productBatch.batchStockDetails.selectedUnit = item.unit.id;
      
      if (
        this.selectedWarehouse &&
        this.selectedWarehouse != this.selectedProductDetails.wareHouse.id
      ) {
        this.$confirm(
          `you can transfer to one warehouse at a time Do you want to change to new Warehouse  previous selected warehouse Transfer will be lost`
        ).then((res) => {
          if (res) {
            this.selectedItemToTransfer = [];
            this.selectedWarehouse = this.selectedProductDetails.wareHouse.id;
            if (item.isTransfer) {
              item.error = [];

              this.selectedItemToTransfer.push(_.cloneDeep(product));
            } else {
              let index = this.selectedItemToTransfer.findIndex(
                (p) =>
                  p.product.id == this.selectedProductDetails.product.id &&
                  p.warehouse.id == item.wareHouse.id &&
                  p.batch.id == item.batch.id
              );
              if (index != -1) {
                this.selectedItemToTransfer.splice(index, 1);
              }
            }
          } else {
            item.isTransfer = false;
          }
        });
      } else {
        this.selectedWarehouse = this.selectedProductDetails.wareHouse.id;
        if (item.isTransfer) {
          item.error = [];
          this.selectedItemToTransfer.push(_.cloneDeep(product));
          item.quantity = item.available_stock;
        } else {
          let index = this.selectedItemToTransfer.findIndex(
            (p) =>
              p.product.id == this.selectedProductDetails.product.id &&
              p.warehouse.id == this.selectedProductDetails.wareHouse.id &&
              p.batch.id == item.batch.id
          );
          if (index != -1) {
            this.selectedItemToTransfer.splice(index, 1);
          }
        }
      }
    },
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    refreshData() {
      this.stocks = [];
      this.$refs.pagination.refreshData();
    },
    setResponseData(productData) {
      this.stocks = this.groupStock(productData);
    },
    groupStock(productData) {
      let groupedArray = _.groupBy(productData, function (entry) {
        return (
          entry.wareHouse.id + "," + entry.unit.id + "," + entry.product.id
        );
      });
      return Object.keys(groupedArray).map((key) => {
        let actual_stock = _.sumBy(groupedArray[key], "actual_stock");
        let available_stock = _.sumBy(groupedArray[key], "available_stock");
        let background = "green";
        if (0 < available_stock > groupedArray[key][0].reorder_level) {
          background = "orange";
        } else if (available_stock <= 0) {
          let background = "#dd000017";
        }
        return {
          actual_stock: actual_stock,
          available_stock: available_stock,
          batch: groupedArray[key][0].batch,
          damage: _.sumBy(groupedArray[key], "damage"),
          id: groupedArray[key][0].id,
          product: groupedArray[key][0].product,
          reorder_level: groupedArray[key][0].reorder_level,
          unit: groupedArray[key][0].unit,
          wareHouse: groupedArray[key][0].wareHouse,
          background: background,
        };
      });
    },
    clearFilter() {
      this.filter = {};
    },
    GetBatchDetails(event) {
      this.progressBar = true;
      if (this.expanded.length > 0 && this.expanded[0].id == event.id) {
        this.expanded = [];
      } else {
        this.selectedProductDetails = event;
        console.log(event, "event");
        const payload = new Object();
        payload.product_id = event.product.id;
        payload.warehouse_id = event.wareHouse.id;
        payload.unit_id = event.unit.id;
        this.$store
          .dispatch("stock/GetBatchForStocksinExpandTable", payload)
          .then((resp) => {
            this.progressBar = false;
            this.stockBatches = resp.map((element) => {
              let selectedProduct = this.selectedItemToTransfer.find(
                (p) =>
                  p.product.id == event.product.id &&
                  p.wareHouse.id == event.wareHouse.id &&
                  p.batch.id == r.batch.id
              );
              if (selectedProduct) {
                element.isTransfer = true;
              } else {
                element.isTransfer = false;
              }
              return {
                ...element,
                transferQuantity: event.quantity,
                sellingPrice: element.units[0].selling_price,
                unit: event.unit,
              };
            });
          })
          .catch((error) => console.log(error));
        this.expanded = [];
        this.progressBar = false;
        this.expanded.push(event);
      }
    },
    getStockColor(stock) {
      console.log(stock);
      if (
        0 < stock.available_stock &&
        stock.available_stock < stock.reorder_level
      ) {
        return "orange";
      } else if (stock.available_stock < 1) {
        return "red";
      } else {
        return "green";
      }
    },
  },
  computed: {
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {},
};
</script>
